import React from "react";
import { Link } from "react-router-dom";
import { RenderNumber } from "../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
import { CONFIG_TEXTOS_ACOPIO } from "../../../config/textosAcopio";
import { EstadoAlmacenInventario } from "../../../components/Almacenes/EstadoAlmacenInventario";
import { ESTADOS_INV_ALMACEN } from "../../../../../../../utility/constants";
const verIcon = require("assets/img/icons/ver.png");

// enlace es opcional: las celdas que llevan a un detalle lo reciben, el resto se
// pintan como texto
const CantidadCelda = ({ valor, enlace, titulo }) => {
    const cantidad = (
        <NullableValue value={valor}>
            <RenderNumber value={valor} decimalScale={3} />
        </NullableValue>
    );

    return (
        <td className="text-center text-nowrap">
            {enlace ? (
                <Link
                    to={enlace}
                    title={titulo}
                    className="inventario-otros-acopios__enlace-detalle"
                >
                    {cantidad}
                </Link>
            ) : (
                cantidad
            )}
        </td>
    );
};

export const AlmacenesConsultaTable = ({ almacenes = [], categoriaAcopio }) => {
    const textConfig = CONFIG_TEXTOS_ACOPIO[categoriaAcopio];

    return (
        <div className="new-table-wrapper inventario-otros-acopios__table-wrapper mb-4 sticky-header sticky-first-column">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2}>Almacén</th>
                        <th rowSpan={2}>Tipo de materia prima</th>
                        <th colSpan={2}>Inventario inicial</th>
                        <th colSpan={2}>Ingresos</th>
                        <th colSpan={2}>Sobrante</th>
                        <th colSpan={2}>{textConfig.textoEnvio}</th>
                        <th colSpan={2}>Inventario final</th>
                        <th rowSpan={2}>Estado</th>
                        <th rowSpan={2}>Acciones</th>
                    </tr>
                    <tr>
                        <th>Laboratorio</th>
                        <th>Liquidación</th>
                        <th>Laboratorio</th>
                        <th>Liquidación</th>
                        <th>Laboratorio</th>
                        <th>Liquidación</th>
                        <th>Laboratorio</th>
                        <th>Liquidación</th>
                        <th>Laboratorio</th>
                        <th>Liquidación</th>
                    </tr>
                </thead>
                <tbody>
                    {almacenes.length === 0 && (
                        <tr>
                            <td colSpan={14} className="text-center">
                                No hay almacenes disponibles.
                            </td>
                        </tr>
                    )}
                    {almacenes.map((item) => {
                        // El almacén sin fila en el inventario del otro acopio no
                        // tiene detalle que abrir
                        const enlaceIngresos = item.inventario_almacen_id
                            ? `/inventarios-almacen/otros-acopios/ingresos/${item.inventario_almacen_id}`
                            : null;

                        // El detalle del sobrante tiene algo que mostrar si el
                        // almacén reportó sobrante en el periodo, o si dejó un
                        // análisis pendiente: ahí todavía no hay kg secos, pero
                        // sí los kg húmedos que se mandaron al laboratorio
                        const tieneDetalleSobrante =
                            item.sobrante.kg_secos_lab > 0 ||
                            item.sobrante.kg_secos_liq > 0 ||
                            item.estado ===
                                ESTADOS_INV_ALMACEN.PENDIENTE_ANALISIS;

                        const enlaceSobrante =
                            item.inventario_almacen_id && tieneDetalleSobrante
                                ? `/inventarios-almacen/otros-acopios/sobrante/${item.inventario_almacen_id}`
                                : null;

                        return (
                        <tr key={item.almacen_id}>
                            <td className="text-center text-nowrap">
                                {item.nombre_almacen}
                            </td>
                            <td className="text-center text-nowrap">
                                {item.materia_prima}
                            </td>

                            <CantidadCelda
                                valor={item.inicial.kg_secos_lab}
                            />
                            <CantidadCelda
                                valor={item.inicial.kg_secos_liq}
                            />

                            <CantidadCelda
                                valor={item.ingresos.kg_secos_lab}
                                enlace={enlaceIngresos}
                                titulo="Ver ingresos del periodo"
                            />
                            <CantidadCelda
                                valor={item.ingresos.kg_secos_liq}
                                enlace={enlaceIngresos}
                                titulo="Ver ingresos del periodo"
                            />

                            <CantidadCelda
                                valor={item.sobrante.kg_secos_lab}
                            />
                            <CantidadCelda
                                valor={item.sobrante.kg_secos_liq}
                            />

                            <CantidadCelda
                                valor={item.enviado.kg_secos_lab}
                            />
                            <CantidadCelda
                                valor={item.enviado.kg_secos_liq}
                            />

                            <CantidadCelda valor={item.final.kg_secos_lab} />
                            <CantidadCelda valor={item.final.kg_secos_liq} />

                            <td>{EstadoAlmacenInventario(item.estado)}</td>

                            <td className="text-center text-nowrap">
                                {enlaceSobrante ? (
                                    <div className="table-actions">
                                        <Link to={enlaceSobrante}>
                                            <img
                                                src={verIcon}
                                                alt="Ver detalle del sobrante"
                                                className="action_img"
                                                title="Ver detalle del sobrante"
                                            />
                                        </Link>
                                    </div>
                                ) : (
                                    <span>—</span>
                                )}
                            </td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
